import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getEmailTemplateSettingsAsync, createEmailTemplateSettingsAsync, updateEmailTemplateSettingsAsync, sendEmailTemplateAsync, getEmailTemplateScheduledStatusAsync } from './emailTemplateSettingsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const emailTemplateSettingsSlice = createSlice({
    name: 'emailTemplateSettings',
    initialState,
    reducers: {
        resetEmailTemplateSettingsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearEmailTemplateSettings(state) {
            state.emailTemplateSettings = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmailTemplateSettingsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplateSettingsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailTemplateSettings = action.payload;
        })
            .addCase(getEmailTemplateSettingsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(createEmailTemplateSettingsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEmailTemplateSettingsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailTemplateSettings = action.payload;
        })
            .addCase(createEmailTemplateSettingsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updateEmailTemplateSettingsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateEmailTemplateSettingsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.updateEmailTemplateSettingsStatus = action.payload;
            if (action.payload.data) {
                state.emailTemplateSettings = action.payload.data;
            }
        })
            .addCase(updateEmailTemplateSettingsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(sendEmailTemplateAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(sendEmailTemplateAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.sentEmailTemplateStatus = action.payload;
        })
            .addCase(sendEmailTemplateAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEmailTemplateScheduledStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplateScheduledStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.scheduledStatusList = action.payload;
        })
            .addCase(getEmailTemplateScheduledStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetEmailTemplateSettingsApiState, clearEmailTemplateSettings } = emailTemplateSettingsSlice.actions;
export default emailTemplateSettingsSlice.reducer;
